import { isEmpty } from 'lodash';
import { ReactNode } from 'react';

export const checkDataBeforeRendering = (data: ExpectedAny, nodes: ReactNode) => {
  if (!data || isEmpty(data)) {
    return null;
  }
  return nodes;
};
